class OrphanLabsClinician {
    public Id: string;
    public Name: string;
    public DateFrom: string;
    public DateTo: string;
    public LicenceNumber: string;

    public constructor(fields?: Partial<OrphanLabsClinician>) {
        Object.assign(this, fields);
    }
}

export { OrphanLabsClinician };
